import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getFavorite = ({ courseId }) => httpClient.get(`${apis.GET_FAVORITE}/${courseId}`);
